import React from 'react';
import { styled } from 'linaria/react';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
interface Props {
  title: string;
  onClick?: () => void;
  modal?: boolean;
  cashback?: boolean;
  icon?: React.ReactElement;
}
export const ButtonDone = ({
  title,
  onClick,
  modal,
  icon,
  cashback
}: Props) => {
  const {
    isMobile
  } = useBreakpoint();
  return <ButtonWrapper onClick={onClick} isMobile={isMobile} modal={modal} cashback={cashback}>
      <Text cashback={cashback}>
        {title}
        <div>{icon && icon}</div>
      </Text>
    </ButtonWrapper>;
};
interface ButtonWrapperProps {
  isMobile: boolean;
  modal?: boolean;
  cashback?: boolean;
}
const _exp3 = /*#__PURE__*/() => ({
  modal
}) => modal ? '0px 4px 0px 0px #110e25' : '0px 4px 0px 0px #110e25';
const _exp4 = /*#__PURE__*/() => ({
  cashback
}) => cashback ? '8px 10px' : '18px 10px';
const _exp5 = /*#__PURE__*/() => ({
  cashback
}) => cashback ? '44px' : 'auto';
const _exp6 = /*#__PURE__*/() => ({
  modal,
  theme
}) => modal ? theme.colors.state.alternativeSecondaryHover : theme.colors.state.secondaryHover;
const _exp7 = /*#__PURE__*/() => ({
  modal,
  theme
}) => modal ? theme.colors.state.alternativeSecondaryTap : theme.colors.state.secondaryTap;
const _exp8 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'none' : 'translateY(4px)';
const ButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "ButtonWrapper",
  class: "b1coqaon",
  propsAsIs: false,
  vars: {
    "b1coqaon-0": [_exp3()],
    "b1coqaon-1": [_exp4()],
    "b1coqaon-2": [_exp5()],
    "b1coqaon-3": [_exp6()],
    "b1coqaon-4": [_exp7()],
    "b1coqaon-5": [_exp8()]
  }
}));
interface TextProps {
  cashback?: boolean;
}
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxs;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.bold;
const _exp10 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxxs;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp12 = /*#__PURE__*/() => ({
  cashback
}) => cashback ? '4px 8px 0px 8px' : '0';
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "tgih2zv",
  propsAsIs: false,
  vars: {
    "tgih2zv-0": [_exp9()],
    "tgih2zv-1": [_exp0(), "px"],
    "tgih2zv-2": [_exp1()],
    "tgih2zv-3": [_exp10(), "px"],
    "tgih2zv-4": [_exp11()],
    "tgih2zv-5": [_exp12()]
  }
}));

require("./ButtonDone.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ButtonDone.tsx");